import { CommonWrap } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";
import { useLocales } from "@/locales";
import CodeSnippet from "@/components/CodeSnippet";
import ShowTable from "@/DocLayout/Table/index";
import { CREATE_INVOCIE_API_INFO } from "@/config";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { useContext } from "react";
import PostRequest from "@/components/PostRequest";

export default function InvoiceInfo({
  url: CREATE_INVOCIE_API_INFO_,
}: {
  url: string;
}) {
  const { translate } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  const invoice_info = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
        "orderId": "172707....",
        "createAt": 1727074590,
        "product": "test",
        "price": "1",
        "priceCoinId": 1280,
        "priceSymbol": "USDT",
        "invoiceUrl": "https://i.ccpayment.com/xxxxx",
        "buyerEmail": "CCPaymentOfficial@proton.me",
        "expiredAt": 1727160989,
        "totalPaidValue": "1.022400000000000008",
        "paidList": [
            {
                "recordId": "2024092306573418982494067xxxxx",
                "coinId": 1280,
                "coinSymbol": "USDT",
                "chain": "BSC",
                "fromAddress": "0x4766dc5207f5172c05da8d4f1dxxxxxxx",
                "toAddress": "0xc53be3a4c137098200aa508dcfe6axxxxxxx",
                "toMemo": "",
                "paidAmount": "0.5",
                "serviceFee": "0.0015",
                "txid": "0xf227c25d124317a4b80094c0d55f5f248082636dbf3fca21fea3bxxxxxxxx",
                "status": "Success",
                "arrivedAt": 1727074654,
                "rate": "1",
                "paidValue": "0.5"
            },
            {
                "recordId": "20240923070723189827xxxxxxxxx",
                "coinId": 1340,
                "coinSymbol": "CELO",
                "chain": "CELO",
                "fromAddress": "0x4766dc5207f5172c05da8d4f1d6659xxxxxxxx",
                "toAddress": "0xc53be3a4c137098200aa508dcfe6a02axxxxxxxx",
                "toMemo": "",
                "paidAmount": "1",
                "serviceFee": "0.003",
                "txid": "0xba302c48b2169f4b853c98d0e618276fa5f93acd54b1f23a8b64310xxxxxxx",
                "status": "Success",
                "arrivedAt": 1727075243,
                "rate": "1.9142419601837672",
                "paidValue": "0.522400000000000008"
            }
        ]
    }
}`,
    go: {
      http_ex_code: `package main

import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "encoding/json"
    "fmt"
    "io/ioutil"
    "net/http"
    "strconv"
    "time"
)

func main() {
    appID := "*** your app_id ***"
    appSecret := "*** your app_secret ***"
    url := "${CREATE_INVOCIE_API_INFO_}"

    // Construct request payload as a map
    content := map[string]string{
        "orderId":    "1xxxxxx",
    }

    // Get current timestamp in seconds
    timestamp := strconv.FormatInt(time.Now().Unix(), 10)

    // Marshal the content map into a JSON string
    bodyBytes, err := json.Marshal(content)
    if err != nil {
        fmt.Println("Error marshaling content:", err)
        return
    }
    body := string(bodyBytes)

    signText := appID + timestamp
    if len(body) != 2 {
        signText += body
    } else {
        body = ""
    }

    serverSign := generateHMACSHA256(signText, appSecret)

    req, err := http.NewRequest("POST", url, bytes.NewBuffer([]byte(body)))
    if err != nil {
        fmt.Println("Error creating request:", err)
        return
    }

    req.Header.Set("Content-Type", "application/json;charset=utf-8")
    req.Header.Set("Appid", appID)
    req.Header.Set("Sign", serverSign)
    req.Header.Set("Timestamp", timestamp)

    client := &http.Client{}
    resp, err := client.Do(req)
    if err != nil {
        fmt.Println("Error making request:", err)
        return
    }
    defer resp.Body.Close()

    bodyResp, err := ioutil.ReadAll(resp.Body)
    if err != nil {
        fmt.Println("Error reading response:", err)
        return
    }

    fmt.Println("Response:", string(bodyResp))
}

func generateHMACSHA256(data, secret string) string {
    key := []byte(secret)
    h := hmac.New(sha256.New, key)
    h.Write([]byte(data))
    return hex.EncodeToString(h.Sum(nil))
}
`,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `import org.json.JSONObject;

import javax.crypto.Mac;
import javax.crypto.spec.SecretKeySpec;
import java.net.HttpURLConnection;
import java.net.URL;
import java.nio.charset.StandardCharsets;
import java.util.Scanner;

public class getInvoiceOrderInfo {

public static void main(String[] args) {
    try {
        String appId = "*** your app_id ***";
        String appSecret = "*** your app_secret ***";
        String url = "${CREATE_INVOCIE_API_INFO_}";

        // Construct the JSON content
        JSONObject content = new JSONObject();
        content.put("orderId", "xxxxxxxx");

        // Get current timestamp
        long timestamp = System.currentTimeMillis() / 1000;
        String body = content.toString();
        String signText = appId + timestamp;

        // Append body to signText if body length is not 2
        if (body.length() != 2) {
            signText += body;
        } else {
            body = "";
        }

        // Generate HMAC SHA256 signature
        String serverSign= generateHMACSHA256Signature(signText,appSecret);

        // Make the POST request
        URL apiUrl = new URL(url);
        HttpURLConnection connection = (HttpURLConnection) apiUrl.openConnection();
        connection.setRequestMethod("POST");
        connection.setRequestProperty("Content-Type", "application/json;charset=utf-8");
        connection.setRequestProperty("Appid", appId);
        connection.setRequestProperty("Sign", serverSign);
        connection.setRequestProperty("Timestamp", String.valueOf(timestamp));
        connection.setDoOutput(true);

        // Write request body if not empty
        if (!body.isEmpty()) {
            connection.getOutputStream().write(body.getBytes(StandardCharsets.UTF_8));
        }

        // Get the response
        int responseCode = connection.getResponseCode();
        if (responseCode == HttpURLConnection.HTTP_OK) {
            Scanner scanner = new Scanner(connection.getInputStream());
            StringBuilder response = new StringBuilder();
            while (scanner.hasNext()) {
                response.append(scanner.nextLine());
            }
            scanner.close();

            // Parse and print JSON response
            JSONObject jsonResponse = new JSONObject(response.toString());
            System.out.println(jsonResponse.toString(4));  // Pretty print
        } else {
            System.out.println("Error: " + responseCode);
        }

    } catch (Exception e) {
        e.printStackTrace();
    }
}

public static String generateHMACSHA256Signature(String data, String key) throws Exception {
    Mac mac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKeySpec = new SecretKeySpec(key.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    mac.init(secretKeySpec);


    byte[] rawHmac = mac.doFinal(data.getBytes(StandardCharsets.UTF_8));
    StringBuilder hexString = new StringBuilder();
    for (byte b : rawHmac) {
        String hex = Integer.toHexString(0xff & b);
        if (hex.length() == 1) {
            hexString.append('0');
        }
        hexString.append(hex);
    }

    return hexString.toString();
}
}`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `import json
import time
import hmac
import hashlib
import binascii
import requests

app_id = "*** your app_id ***"
app_secret = "*** your app_secret ***"
url = "${CREATE_INVOCIE_API_INFO_}"
content = {
    "orderId": "xxxxxxx"
}

timestamp = int(time.time())
body = json.dumps(content)
sign_text = f"{app_id}{timestamp}"
if len(body) != 2:
  sign_text = f"{sign_text}{body}"
else:
  body = ""

h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
server_sign = binascii.hexlify(h.digest()).decode('utf-8')

res = requests.post(url=url,
  headers={
    "Content-Type": "application/json;charset=uf8",
    "Appid": app_id,
    "Sign": server_sign,
    "Timestamp": f"{timestamp}"},
  data=body
  )
print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const crypto = require('crypto');
const axios = require('axios');

// Configuration variables
const appID = "*** your app_id ***";
const appSecret = "*** your app_secret ***";
const url = "${CREATE_INVOCIE_API_INFO_}";

// Build request body
const content = {
    orderId: "xxxxxxxx",
};

// Get the current timestamp (in seconds)
const timestamp = Math.floor(Date.now() / 1000);

// Convert the content object to a JSON string
let body = JSON.stringify(content);

// Create the signature base string
let signText = appID + timestamp;
if (body.length !== 2) { // Check if the body is an empty object
    signText += body;
} else {
    body = "";
}

// Generate HMAC SHA256 signature
function generateHMACSHA256(data, secret) {
    return crypto.createHmac('sha256', secret).update(data).digest('hex');
}

const serverSign = generateHMACSHA256(signText, appSecret);

// Set HTTP request headers
const headers = {
    'Content-Type': 'application/json;charset=utf-8',
    'Appid': appID,
    'Sign': serverSign,
    'Timestamp': timestamp
};

// Send the HTTP POST request
axios.post(url, body, { headers })
    .then(response => {
        console.log("Response:", response.data);
    })
    .catch(error => {
        console.error("Error making request:", error.message);
    });
`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
$appID = "*** your app_id ***";
$appSecret = "*** your appSecret ***";
$url = "${CREATE_INVOCIE_API_INFO_}";

// Construct request payload as an associative array
$content = [
    "orderId" => "xxxxxxx",
];

// Get current timestamp in seconds
$timestamp = time();

// Convert the content array to a JSON string
$body = json_encode($content);

// Create the signature base string
$signText = $appID . $timestamp;
if (strlen($body) != 2) {
    $signText .= $body;
} else {
    $body = "";
}

// Generate HMAC SHA256 signature
$serverSign = generateHMACSHA256($signText, $appSecret);

// Initialize cURL session
$ch = curl_init($url);

// Set cURL options
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
curl_setopt($ch, CURLOPT_POST, true);
curl_setopt($ch, CURLOPT_POSTFIELDS, $body);
curl_setopt($ch, CURLOPT_HTTPHEADER, [
    "Content-Type: application/json;charset=utf-8",
    "Appid: $appID",
    "Sign: $serverSign",
    "Timestamp: $timestamp"
]);

// Execute cURL request and get response
$response = curl_exec($ch);

// Check for cURL errors
if (curl_errno($ch)) {
    echo "Error making request: " . curl_error($ch);
    curl_close($ch);
    exit;
}

// Close cURL session
curl_close($ch);

// Output the response
echo "Response: " . $response;

// Function to generate HMAC SHA256 signature
function generateHMACSHA256($data, $secret) {
    return hash_hmac('sha256', $data, $secret);
}
?>
`,
      example_code: ``,
      example_code2: ``,
    },
  };
  return (
    <>
      <ContentWrap
        id="invoice-api-info"
        showBorderBottom={false}
        leftChildrenSx={{
          paddingBottom: "1px",
        }}
        leftChildren={
          <CommonWrap>
            <Box id="swap-price" component={"div"} className="title_0" mt={3}>
              {translate("merchant_app_mode_API.text_161")}
            </Box>

            <Box component={"div"} className="desc" mt={3}>
              {translate("merchant_app_mode_API.text_162")}
            </Box>

            <Box component={"div"} className="title_1" mt={3}>
              {translate("common.http_request")}
            </Box>

            <Box component={"div"} className="desc" mb={3}>
              <PostRequest url={CREATE_INVOCIE_API_INFO} />
            </Box>
          </CommonWrap>
        }
      />
      <ContentWrap
        showBorderBottom={false}
        leftChildrenSx={{
          paddingTop: "32px",
          paddingBottom: "1px",
        }}
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_params")}</Box>
            <ShowTable
              tableData={[
                {
                  name: "orderId",
                  type: "String",
                  is_: translate("common.params_is"),
                  desc: translate("merchant_app_mode_API.text_163"),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <>
            <CodeSnippet
              title={translate("common.http_request_ex")}
              code={invoice_info[language].http_ex_code}
            />
          </>
        }
      />

      {/* 返回参数 */}

      <ContentWrap
        leftChildrenSx={{
          paddingTop: "2px",
        }}
        leftChildren={
          <CommonWrap>
            <Box component={"div"} className="title_1" mt={3}>
              {translate("common.http_res")}
            </Box>

            <ShowTable
              res={true}
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: " ",
                },
                {
                  name: "data.orderId",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_164"),
                },
                {
                  name: "data.createAt",
                  type: "Integer",
                  desc: translate("merchant_app_mode_API.text_165"),
                },
                {
                  name: "data.product",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_166"),
                },
                {
                  name: "data.price",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_167"),
                },
                {
                  name: "data.priceFiatId",
                  type: "Integer",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_168"
                        )} ` as any,
                      }}
                    />
                  ),
                },

                {
                  name: "data.priceCoinId",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_169"
                        )} ` as any,
                      }}
                    />
                  ),
                },

                {
                  name: "data.priceSymbol",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_170"),
                },
                {
                  name: "data.invoiceUrl",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_171"),
                },
                {
                  name: "data.expiredAt",
                  type: "Integer",
                  desc: translate("merchant_app_mode_API.text_172"),
                },
                {
                  name: "data.totalPaidValue",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_173"),
                },
                {
                  name: "data.buyerEmail",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_174"),
                },
                {
                  name: "data.paidList",
                  type: "Array",
                  desc: translate("merchant_app_mode_API.text_175"),
                },
                {
                  name: "data.paidList[index].recordId",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_176"),
                },
                {
                  name: "data.paidList[index].coinId",
                  type: "Integer",
                  desc: translate("merchant_app_mode_API.text_177"),
                },
                {
                  name: "data.paidList[index].coinSymbol",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_178"),
                },
                {
                  name: "data.paidList[index].paidAmount",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_179"),
                },
                {
                  name: "data.paidList[index].serviceFee",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_180"),
                },
                {
                  name: "data.paidList[index].rate",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_181"),
                },

                {
                  name: "data.paidList[index].paidValue",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_182"),
                },
                {
                  name: "data.paidList[index].chain",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_183"),
                },
                {
                  name: "data.paidList[index].fromAddress",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_184"),
                },
                {
                  name: "data.paidList[index].toAddress",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_185"),
                },
                {
                  name: "data.paidList[index].toMemo",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_186"),
                },
                {
                  name: "data.paidList[index].txid",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_187"),
                },
                {
                  name: "data.paidList[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_188"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.paidList[index].arrivedAt",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_189"),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <>
            <CodeSnippet
              title={translate("common.http_result")}
              code={invoice_info.response}
            />
          </>
        }
      />
    </>
  );
}
